import React from 'react';
import { Link } from 'react-router-dom';
import ServicesHero from './ServicesHero';
import ServicesPage from './ServicesPage';

const Services = () => {
  const allServices = [
    {
      title: "ATS Resume Checker",
      desc: "Optimize your resume for applicant tracking systems.",
      path: "/ats-score",
      icon: "📊"
    },
    {
      title: "AI Resume Builder",
      desc: "Create professional resumes with our AI-powered templates.",
      path: "/resume-builder",
      icon: "📄"
    },
    {
      title: "Online Code Compiler",
      desc: "Write and run code in multiple languages instantly.",
      path: "/compiler",
      icon: "💻"
    },
    {
      title: "Job Email Builder",
      desc: "Craft perfect emails to recruiters using AI.",
      path: "/email-builder",
      icon: "📧"
    }
  ];

  return (
    <main className="pt-[140px] pb-20 bg-slate-50 dark:bg-slate-950 min-h-screen">
        {/* <ServicesHero/> */}
      <ServicesPage/>
    </main>
  );
};

export default Services;